module.exports = __webpack_public_path__ + "img/adas-solution-introduction-image.7c31ea8b.png";